import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { FadeIn } from './ui/FadeIn';
export function ParaQuien() {
  const items = [{
    icon: '🚗',
    text: 'Tenés un auto usado y cada visita al taller te genera desconfianza.'
  }, {
    icon: '🏍️',
    text: 'Usás moto para laburar, estudiar o moverte todos los días.'
  }, {
    icon: '❓',
    text: 'Querés entender y cuestionar cada presupuesto.'
  }, {
    icon: '🔧',
    text: 'Querés aprender mantenimientos básicos vos mismo.'
  }, {
    icon: '💰',
    text: 'Querés cuidar tu vehículo sin que te vean la cara.'
  }];
  return <section className="bg-mc-dark2 py-[72px] px-5" data-id="element-124">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-125">
        <FadeIn data-id="element-126">
          <SectionHeading centered data-id="element-127">Este pack es para vos si…</SectionHeading>
        </FadeIn>

        <ul className="flex flex-col gap-3.5 mt-8 max-w-[680px] mx-auto text-left list-none" data-id="element-128">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-129">
              <li className="flex items-start gap-3.5 bg-mc-gray rounded-lg py-4 px-5 text-gray-200 text-[0.98rem]" data-id="element-130">
                <span className="text-[1.4rem] shrink-0" data-id="element-131">{item.icon}</span>
                <span data-id="element-132">{item.text}</span>
              </li>
            </FadeIn>)}
        </ul>
      </div>
    </section>;
}